import styledCache from './styledCache';
import { getInnerStyles } from '../styled/utils';

export default styledCache(getInnerStyles);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/avatar/dist/esm/helpers/getStyledAvatar.js
// module id = 758
// module chunks = 0